// extracted by mini-css-extract-plugin
module.exports = {"container":"clients_container__3DUNn"};